import { getScoreIdParts } from '@ilg-totallymoney/cardloanutils'

import { getAppConfig } from './getAppConfig'

interface GetLoansAlternativeProductApplicationUrlOptions {
    cam?: string
    customerId: string
    customerOrigin?: string
    customerType?: string
    dailyId: string
    gclid?: string
    k?: string
    leadId?: string
    loanAmount: number
    loanTerm: number
    m?: string
    permanentId: string
    productId: string
    rowNumber: number
    scoreId: string
    visitGuid: string
    whitelabelName: string
}

const appConfig = getAppConfig()

export const getLoansAlternativeProductApplicationUrl = (
    options: GetLoansAlternativeProductApplicationUrlOptions
) => {
    const url = new URL(
        `${appConfig.LOANS_CLICK_OUT_URL}loan-application/${options.productId}/`
    )

    const query = {
        partner: options.whitelabelName,
        visitGuid: options.visitGuid,
        dailyId: options.dailyId,
        permanentId: options.permanentId,
        loanTerm: options.loanTerm,
        loanAmount: options.loanAmount,
        m: options.m,
        k: options.k,
        cam: options.cam,
        gclid: options.gclid,
        customerId: options.customerId,
        customerOrigin: options.customerOrigin,
        customerType: options.customerType,
        scoreId: options.scoreId,
        leadId: options.scoreId
            ? getScoreIdParts(options.scoreId).leadId
            : undefined,
        rowNumber: options.rowNumber,
    }

    Object.keys(query).forEach(key => {
        const queryKey = key as keyof typeof query
        const queryValue = query[queryKey]

        if (queryValue != null) {
            url.searchParams.set(key, `${queryValue}`)
        }
    })

    return url.toString()
}
